import { fromJS } from "immutable";

import { currentUserActions } from "actions/currentUserActions.js";

const initialState = fromJS({
  isLoading: true,
  hasErrors: false,
  data: {
    name: null,
    email: null,
    company: null,
    role: null,
    time_zone: null,
    locale: null,
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case currentUserActions.startLoader:
      localStorage.removeItem("hide_whole_sale_price");
      localStorage.setItem("hide_whole_sale_price", "false");
      return state.set("isLoading", true);
    case currentUserActions.reset:
      localStorage.removeItem("hide_whole_sale_price");
      localStorage.setItem("hide_whole_sale_price", "false");
      return initialState;
    case currentUserActions.logout:
      localStorage.removeItem("hide_whole_sale_price");
      localStorage.setItem("hide_whole_sale_price", "false");
      return initialState;
    case currentUserActions.success:
      localStorage.removeItem("hide_whole_sale_price");
      localStorage.setItem("hide_whole_sale_price", "false");
      return state.merge({
        isLoading: false,
        hasErrors: false,
        data: fromJS(action.payload.data)
      });
    case currentUserActions.failure:
      return state.merge({
        isLoading: false,
        hasErrors: true,
        data: fromJS(action.payload.data)
      });
    default:
      return state;
  }
};
